export default {
	title: 'presence_configuration',
	component: 'presence_configuration',
};
